/* eslint-disable no-alert, no-console */

let FETCH_DELAY = 500
let PRELOAD_DELAY = 500

const log = (msg, ...args) => {
  console.log('%cLABELBOX: ' + msg, 'font-weight: bold;', ...args)
}

const dataset = []
const limit = 8

for (let i = 1; i <= limit; i++) {
  dataset.push({
    id: `uniq${i}`,
    data: JSON.stringify({
      eventId: i.toString(),
      menuId: i.toString(),
      installationId: i.toString()
    })
  })
}

let subscriber = null
let preloader = null
let currentIndex = 0

const fetchData = () => {
  setTimeout(() => {
    log('fetchNextAssetToLabel', dataset[currentIndex])
    subscriber(dataset[currentIndex])
  }, FETCH_DELAY)
  setTimeout(() => {
    if (currentIndex < limit - 1) {
      log('preload', dataset[currentIndex + 1])
      preloader(dataset[currentIndex + 1])
    }
  }, PRELOAD_DELAY)
}

export default {
  currentAsset() {
    return {
      subscribe(callback) {
        subscriber = callback
      }
    }
  },

  enablePreloading({ preloadFunction }) {
    preloader = preloadFunction
  },

  setLabelForAsset(payload) {
    return new Promise((resolve, reject) => {
      log('setLabelForAsset', payload)
      resolve()
    })
  },

  fetchNextAssetToLabel() {
    if (currentIndex === limit - 1) {
      log('[DONE]')
      alert('[DONE]')
    }

    currentIndex++
    fetchData()
  },

  init(delay = 500) {
    FETCH_DELAY = delay
    PRELOAD_DELAY = delay

    fetchData()
  }
}
